
<div class="scad-body">
  <app-sidebar></app-sidebar>
  <div class="scad-body__wrapper" [ngClass]="{'full-width': sideBarMinimized || sideBartoggle }">
      <app-header></app-header>
      <div class="scad-body__main">
        <router-outlet></router-outlet>
      </div>
  </div>
</div>
